import { PrimaryButton } from './primary-button';
import { SecondaryButton } from './secondary-button';
import { withAliases } from '../utils/with-aliases';
import { OutlineButton } from './outline-button';
import { TextButton } from './text-button';
import { LightButton } from './light-button';
import { DangerButton } from './danger-button';
var aliases = {
    Primary: PrimaryButton,
    Secondary: SecondaryButton,
    Light: LightButton,
    Outline: OutlineButton,
    Danger: DangerButton,
    Text: TextButton,
};
export var Button = withAliases(PrimaryButton, aliases);
